import { IMembers, ISites, MemberRole } from "types";

export interface IRemoveSite {
  site?: ISites;
  onSuccess?: () => void;
}
export interface IRemoveMember {
  member: IMembers;
  onSuccess?: () => void;
}
export interface MemberState {
  name: string;
  email: string;
  role: MemberRole;
}
export const initState: MemberState = {
  email: "",
  name: "",
  role: "user"
};
export const defaultState =
  process.env.NODE_ENV === "development"
    ? ({
        email: "test@user.com",
        name: "Test User",
        role: "user"
      } as MemberState)
    : initState;
